module.exports = __webpack_public_path__ + "media/assets/icons/vaadin_time-forward-0444da79f962abe04e6565a35ae22c51.svg";